import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { useDict } from "@/i18n/dict";
import RecipeCard from "@/components/RecipeCard";

export default function SelectionPage() {
  const { slug } = useParams();
  const { lang } = useLang();
  const t = useDict(lang);
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setData(null);
    api.getSelection(slug).then(setData).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-32 text-center font-serif-display text-3xl italic">Sélection introuvable</div>;
  if (!data) return <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-32" />;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16">
      <Link to="/recipes" data-testid="selection-back" className="text-xs tracking-[0.22em] uppercase font-medium hover:opacity-60 mb-8 inline-block">{t.recipe.backToAll}</Link>
      <p className="eyebrow mb-4">{t.sectionSeeAll === 'See all' ? 'Curated selection' : 'Sélection thématique'}</p>
      <h1 data-testid="selection-title" className="font-serif-display text-5xl sm:text-6xl lg:text-7xl tracking-tight mb-6 leading-[0.95]">{data.title[lang] || data.title.fr}</h1>
      <p className="text-lg text-[color:var(--ink-2)] max-w-3xl mb-16 leading-relaxed">{data.subtitle[lang] || data.subtitle.fr}</p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 lg:gap-10 stagger">
        {data.recipes.map((r) => <RecipeCard key={r.slug} recipe={r} testId={`selection-card-${r.slug}`} />)}
      </div>
    </div>
  );
}
